import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import LogoHeader from "../../components/LogoHeader";
import { Footer } from "../../components/Footer";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import { useLocation } from "react-router-dom";
import { useMemo, useEffect, useState } from "react";
import {
  MainContainer,
  StatusIcon,
  FooterWrapper,
  StatusMessageContainer
} from "./components/styles";

const SMART_RETAIL_ERROR = ({ error_message }: { error_message?: string }) => {
  const location = useLocation();
  const { t } = useTranslation();
  const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const errorMessage = searchParams.get("error-msg") || error_message;
  const [errorDisplay1, setErrorDisplay1] = useState("paymentFAIL");
  const [errorDisplay2, setErrorDisplay2] = useState("pleaseTryAgain");

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);


  const errorMap = {
    invalid_qr: ["paymentERROR", "invalidqrcode"],
    campaign_error: ["Error", "PleaseReachOutToCustomerSupport"],
    invalid_request: ["Error", "PleaseReachOutToCustomerSupport"],
    invalid_url: ["invalidURL", "pleaseCheckTheSettings"],
    coupon_failed: ["couponFailed", "PleaseReachOutToCustomerSupport"],
    coupon_error: ["couponError", "PleaseReachOutToCustomerSupport"],
  };

  type ErrorKey = keyof typeof errorMap

  useEffect(() => {
    let [d1, d2] = ["paymentFAIL", "pleaseTryAgain"];

    if (errorMessage && errorMessage in errorMap) {
      [d1, d2] = errorMap[errorMessage as ErrorKey];
    }
    setErrorDisplay1(d1);
    setErrorDisplay2(d2);

  }, [errorMessage]);


  const renderErrorContent = () => (
    <>
      <StatusMessageContainer>
        <Typography className="typography1">{t(errorDisplay1)}</Typography>
        {
          errorMessage === "coupon_failed"
            ? (<StatusIcon />)
            : (
              <StatusIcon>
                <CancelRoundedIcon
                  style={{
                    color: "#a70334",
                    fontSize: "40px",
                  }} />
              </StatusIcon>
            )
        }
        <Typography className="typography2">{t(errorDisplay2)}</Typography>
      </StatusMessageContainer>
    </>
  );


  return (
    <>
      <MainContainer>
        <LogoHeader enableLanguage={true} />
        {renderErrorContent()}
        <FooterWrapper>
          <Footer />
        </FooterWrapper>
      </MainContainer>
    </>
  );
};

export default SMART_RETAIL_ERROR;
